import styled, { css } from "styled-components/macro";
interface IQInvoicesWrapperProps {
  margin_bottom?: boolean;
}
const Wrapper = styled.div<IQInvoicesWrapperProps>(({ theme, margin_bottom }) => {
  return css`
    width: max(75vh, ${theme.rem(24)});
    margin-bottom: ${margin_bottom ? theme.rem(1) : 0};
  `;
});
/**
 * Meldung, wenn der Beleg nicht geoeffnet werden konnte.
 *
 * Der Beleg erscheint sonst in einem ANDEREN Tab - bleibt der aus, gaebe es
 * ohne diese Zeile gar keine Rueckmeldung.
 */
const Message = styled.p(({ theme }) => {
  return css`
    margin: ${theme.rem(0.75)} 0 0;
    color: ${theme.values.colors.global.validation.error};
    font-size: ${theme.rem(0.875)};
  `;
});
export const StyledDownloadInvoices = {
  Wrapper,
  Message,
};
